module.exports = __webpack_public_path__ + "assets/img/txt-professionals-01.d0c91dab.svg";